<template>
	<div>
		<h5>Leave a message for us</h5>
		<FormTemplate
			:formFields="formLayout"
			:formData="formFields"
			@fieldSet="setParentData"
		/>
	</div>
</template>

<script>
import FormTemplate from "@/templates/Form/formTemplate.vue";

export default {
	name: "step-three",
	components: {
		FormTemplate
	},
	data() {
		return {
			formLayout: [
				{
					name: "message",
					tag: "textarea",
					type: "textarea",
          maxlength: 200,
					value: "",
					placeholder: "Your Message",
					label: "",
					class: "input-fullwidth",
				}
			],
			formFields: {
				message: "",
			}
		};
	},
	methods: {
		setParentData(formData) {
			this.$emit("onStepSet", formData);
		}
	}
};
</script>

<style lang="sass" scoped>
</style>